import { Link } from 'react-router-dom';
import { APP_NAME, APP_LOGO_SRC, APP_LOGO_ALT } from '../../config/branding.js';
import { defaultRoute } from '../../config/menuData.js';

/**
 * The layout shells' brand slot:
 *
 *   <a class="navbar-brand" href="#">CreativeStudioOS</a>
 *
 * The placeholder `href="#"` becomes a router link to the design's
 * DefaultMenuItem. The application name and the (currently absent) logo come
 * from src/config/branding.js, so branding is declared once for every layout.
 */
export default function AppBrand({ className = 'navbar-brand' }) {
  return (
    <Link className={className} to={defaultRoute()}>
      {/* DMI runtime brand (html[data-brand='dmi']): the white-glyph DMI logo
          precedes the product name on the dark chrome. Hidden under the
          default brand purely in CSS (scss/_dmi-brand.scss), so switching
          brands never needs a re-render. */}
      <img
        className="app-brand__dmi-logo"
        src="/brand/dmi/dmi-logo-white.png"
        alt="Dubai Media Incorporated"
      />
      {APP_LOGO_SRC ? (
        <img className="header-logo" src={APP_LOGO_SRC} alt={APP_LOGO_ALT} />
      ) : (
        <span className="app-brand__name">{APP_NAME}</span>
      )}
    </Link>
  );
}
